import { flattenSettingsIa, type SettingsLeaf } from '@/components/nav-v2/settings/settings-ia';

export const SETTINGS_VISIBILITY_PAGE_KEY = 'settings:navigation';
export const SETTINGS_VISIBILITY_PREF_TYPE = 'user_pref' as const;

export type SettingsVisibilityPreference = {
  hiddenHrefs: string[];
};

/** Leaves that must always remain reachable for tenant admins. */
export const SETTINGS_VISIBILITY_LOCKED_HREFS = new Set([
  '/settings/organisation',
  '/settings/users',
  '/settings/system',
  '/settings/security',
]);

export function allConfigurableSettingsLeaves(): ReadonlyArray<
  SettingsLeaf & { clusterId: string; clusterTitle: string }
> {
  return flattenSettingsIa().filter((leaf) => !SETTINGS_VISIBILITY_LOCKED_HREFS.has(leaf.href));
}

export function parseSettingsVisibilityPreference(
  visibleKeys: Record<string, unknown> | null | undefined,
  keyOrder: string[] | null | undefined,
): SettingsVisibilityPreference {
  const fromVisible = Object.entries(visibleKeys ?? {})
    .filter(([, value]) => value === false)
    .map(([href]) => href);
  const fromOrder = (keyOrder ?? []).filter(Boolean);
  const hiddenHrefs = [...new Set([...fromVisible, ...fromOrder])];
  return { hiddenHrefs };
}

export function buildSettingsVisibilityPayload(hiddenHrefs: string[]): {
  visible_keys: Record<string, boolean>;
  key_order: string[];
} {
  const hidden = new Set(hiddenHrefs);
  const visible_keys: Record<string, boolean> = {};
  for (const leaf of allConfigurableSettingsLeaves()) {
    if (hidden.has(leaf.href)) {
      visible_keys[leaf.href] = false;
    }
  }
  return {
    visible_keys,
    key_order: hiddenHrefs,
  };
}

export function isSettingsLeafHidden(
  href: string,
  hiddenHrefs: ReadonlySet<string> | readonly string[],
): boolean {
  const hidden = hiddenHrefs instanceof Set ? hiddenHrefs : new Set(hiddenHrefs);
  if (SETTINGS_VISIBILITY_LOCKED_HREFS.has(href)) return false;
  return hidden.has(href);
}
